module.exports = __webpack_public_path__ + "img/diamond.68282d14.svg";